import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
const specs = [{
  value: '04',
  label: 'Bedrooms'
}, {
  value: '02',
  label: 'Bathrooms'
}, {
  value: '02',
  label: 'Garage'
}, {
  value: '650',
  label: 'Sqm'
}];
export function SpecsBar() {
  return <section className="w-full bg-cream border-b border-charcoal/10 relative z-20" data-id="element-73">
      <div className="max-w-4xl mx-auto px-6 py-12 md:py-16" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="flex flex-row flex-wrap justify-center items-center gap-x-8 gap-y-6 md:gap-x-16" data-id="element-75">
          {specs.map((spec, index) => <Fragment key={spec.label} data-id="element-76">
              <div className="flex items-baseline gap-2" data-id="element-77">
                <span className="font-sans text-charcoal text-sm md:text-base font-medium" data-id="element-78">
                  {spec.value}
                </span>
                <span className="text-[10px] md:text-xs text-ink-soft uppercase tracking-[0.2em]" data-id="element-79">
                  {spec.label}
                </span>
              </div>

              {index < specs.length - 1 && <div className="w-[1px] h-4 bg-charcoal/15 hidden md:block" data-id="element-80" />}
            </Fragment>)}
        </motion.div>
      </div>
    </section>;
}